import { Box } from '@mui/material';
import { CustomTextField, HorizontalForm, VerticalForm, DialogTitle } from '../../../common';

const PersonalDataSection = ({ selectedUser, onInputChange, isMobile, editMode }) => {
  const isEmailDisabled = editMode && !!selectedUser?.uuid;

  if (isMobile) {
    return (
      <Box>
        <DialogTitle showSeparator={false} sx={{ p: 0 }}>
          Datos Personales
        </DialogTitle>
        <VerticalForm>
          <CustomTextField
            label="Nombre Completo"
            name="names"
            value={selectedUser.names || ''}
            onChange={onInputChange}
            required
            size="medium"
          />
          <CustomTextField
            label="Email"
            name="email"
            type="email"
            value={selectedUser.email || ''}
            onChange={onInputChange}
            required
            size="medium"
            disabled={isEmailDisabled}
          />
          <CustomTextField
            label="Teléfono"
            name="telephone"
            value={selectedUser.telephone || ''}
            onChange={onInputChange}
            size="medium"
          />
        </VerticalForm>
      </Box>
    );
  }

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos Personales
      </DialogTitle>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Nombre Completo"
            name="names"
            value={selectedUser.names || ''}
            onChange={onInputChange}
            required
            size="medium"
          />
          <CustomTextField
            label="Email"
            name="email"
            type="email"
            value={selectedUser.email || ''}
            onChange={onInputChange}
            required
            size="medium"
            disabled={isEmailDisabled}
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomTextField
            label="Teléfono"
            name="telephone"
            value={selectedUser.telephone || ''}
            onChange={onInputChange}
            size="medium"
          />
        </Box>
      </HorizontalForm>
    </Box>
  );
};

export default PersonalDataSection;
